import { SearchFn, getSearchName } from "../../../../rest/Search";
import { EntityType } from "../../../../models/EntityType";
import { ListActions } from "../../../flux/Grid/ListActions";
import { Entity } from "../../../../models/Entity";
import { Vehicle, ServiceAccount } from "../../../../models";

export class AutoImportWatchActions
{
    private timerId;
    private readonly listActions = new ListActions();

    constructor(private runSearch: SearchFn, private getItems: () => (ServiceAccount|Vehicle)[], private entityType: EntityType)
    {
    }

    startPulling = (msInterval: number): void => {
        this.tryPull();
        this.timerId = setInterval(this.tryPull, msInterval);
    };

    stopPulling = (): void => {
        clearInterval(this.timerId);
        this.timerId = null;
    };

    tryPull = () => {
        const items = this.getItems();
        const ids = items.filter(item => item.OngoingAutoImport).map(item => item.id);
        
        if(ids.length === 0)
            return;
        
        const request = {
            Name: getSearchName(this.entityType),
            Ids: ids
        };
        this.runSearch(request)
            .then(sr => this.listActions.replaceItems(sr.Entries[EntityType[this.entityType]], this.entityType));
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/ServiceAccount/AutoImportWatchActions.ts